import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { fetchEmployees, fetchKpis, saveKpi, saveKpiEntry } from "../../api/HrAPIs";
import { Empty, Field, HrFrame, HrGuard, inputClass, useHr } from "./hrUi";

export default function PerformancePage() {
  return <HrGuard anyOf={["HR.ViewPerformance", "HR.ManageKPIs"]}><Body /></HrGuard>;
}

function Body() {
  const hr = useHr();
  const queryClient = useQueryClient();
  const kpis = useQuery({ queryKey: ["hrKpis"], queryFn: () => fetchKpis() });
  const employees = useQuery({ queryKey: ["hrEmployees", "kpi"], queryFn: () => fetchEmployees({ pageSize: 100 }), enabled: hr.can("HR.ManageKPIs") });
  const [definition, setDefinition] = useState({ code: "", name: "", category: "General", unit: "" });
  const [entry, setEntry] = useState({ employeeId: "", kpiDefinitionId: "", year: new Date().getFullYear(), month: new Date().getMonth() + 1, value: "" });
  const save = async (event) => {
    event.preventDefault();
    try { await saveKpi(definition); toast.success("تمت إضافة المؤشر"); setDefinition({ code: "", name: "", category: "General", unit: "" }); queryClient.invalidateQueries({ queryKey: ["hrKpis"] }); }
    catch (error) { toast.error(error.message); }
  };
  return (
    <HrFrame title="الأداء والمؤشرات" subtitle="مؤشرات خدمة العملاء تُحسب من التذاكر. مؤشرات الإنتاج والتسويق تُسجل لأنها غير مربوطة تلقائياً بموظف.">
      <div className="mb-4 grid gap-2">
        {(kpis.data || []).map((kpi) => <p key={kpi.id} className="rounded-2xl border bg-white p-3 text-sm">{kpi.category} · {kpi.name} · {kpi.unit || ""} {!kpi.isActive && "· متوقف"}</p>)}
        {(kpis.data || []).length === 0 && <Empty text="لا توجد مؤشرات." />}
      </div>
      {hr.can("HR.ManageKPIs") && (
        <>
          <form onSubmit={save} className="mb-4 grid gap-2 rounded-2xl border bg-white p-4 md:grid-cols-2">
            <Field label="الكود"><input className={inputClass} required value={definition.code} onChange={(event) => setDefinition({ ...definition, code: event.target.value })} /></Field>
            <Field label="الاسم"><input className={inputClass} required value={definition.name} onChange={(event) => setDefinition({ ...definition, name: event.target.value })} /></Field>
            <Field label="التصنيف"><input className={inputClass} value={definition.category} onChange={(event) => setDefinition({ ...definition, category: event.target.value })} /></Field>
            <Field label="الوحدة"><input className={inputClass} value={definition.unit} onChange={(event) => setDefinition({ ...definition, unit: event.target.value })} /></Field>
            <button className="rounded-xl bg-indigo-600 px-4 py-2 text-sm text-white">إضافة مؤشر</button>
          </form>
          <form className="grid gap-2 rounded-2xl border bg-white p-4 md:grid-cols-2" onSubmit={async (event) => {
            event.preventDefault();
            try {
              await saveKpiEntry({ ...entry, employeeId: Number(entry.employeeId), kpiDefinitionId: Number(entry.kpiDefinitionId), year: Number(entry.year), month: Number(entry.month), value: Number(entry.value) });
              toast.success("تم تسجيل القيمة");
            } catch (error) { toast.error(error.message); }
          }}>
            <Field label="الموظف">
              <select className={inputClass} required value={entry.employeeId} onChange={(event) => setEntry({ ...entry, employeeId: event.target.value })}>
                <option value="">اختر</option>
                {(employees.data?.items || []).map((item) => <option key={item.id} value={item.id}>{item.fullName}</option>)}
              </select>
            </Field>
            <Field label="المؤشر">
              <select className={inputClass} required value={entry.kpiDefinitionId} onChange={(event) => setEntry({ ...entry, kpiDefinitionId: event.target.value })}>
                <option value="">اختر</option>
                {(kpis.data || []).map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
              </select>
            </Field>
            <Field label="القيمة"><input className={inputClass} type="number" step="0.01" required value={entry.value} onChange={(event) => setEntry({ ...entry, value: event.target.value })} /></Field>
            <button className="rounded-xl bg-slate-900 px-4 py-2 text-sm text-white">تسجيل</button>
          </form>
        </>
      )}
    </HrFrame>
  );
}
